/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Modal, Space, Typography, Row, Col } from 'antd';
import { deleteCompany, getCompanies } from 'api/company';
import { CompanyType } from 'interfaces';
import TableComponent from 'components/TableComponent';
import { handleError, handleSuccess, MessageTypes } from 'utils/handlers';

const { Text, Title } = Typography;

const Company: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [showmodal, setShowModal] = useState<boolean>(false);
  const [companies, setCompanies] = useState<CompanyType[]>([]);
  const [deletecompany, setDeleteCompany] = useState<CompanyType | null>(null);
  const [total, setTotal] = useState<number>(1);
  const [perpage, setPerPage] = useState<number>(10);
  const [currentpage, setCurrentPage] = useState<number>(1);

  const history = useHistory();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    const queryApi = async () => {
      try {
        setLoading(true);
        const response = await getCompanies(perpage, currentpage);
        if (response?.data) {
          const companies = response.data.companies.map(
            (company: CompanyType) => ({
              ...company,
              key: company.id,
            })
          );
          if (isMounted.current) {
            setTotal(response.data.totalCompanies);
            setCompanies(companies);
            setLoading(false);
          }
        }
      } catch (err: any) {
        handleError({ err, type: MessageTypes.error });
        setTimeout(() => {
          history.push('/');
        }, 3000);
      }
    };
    queryApi();
  }, [currentpage, perpage]);

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Abreviación',
      dataIndex: 'abbreviation',
      key: 'abbreviation',
    },
    {
      title: 'Estado',
      dataIndex: 'is_available',
      key: 'is_available',
      render(isAvailable: string | number) {
        return (
          <>
            {isAvailable == 0 ? (
              <Text type="danger">Eliminado</Text>
            ) : (
              <Text type="success">Disponible</Text>
            )}
          </>
        );
      },
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      render(_: unknown, company: CompanyType) {
        return (
          <Space direction="horizontal" size="small" style={{ width: '100%' }}>
            <Link to={`/compañia/editar/${company.id}`}>
              <Button type="link" block>
                Editar
              </Button>
            </Link>

            <Button
              type="link"
              danger
              block
              disabled={!company.is_available && true}
              onClick={() => handleModal('open', company)}
            >
              Eliminar
            </Button>
          </Space>
        );
      },
    },
  ];

  const handleModal = (action: string, company?: CompanyType) => {
    if (action === 'open') {
      setDeleteCompany(company!);
      setShowModal(true);
    } else {
      setDeleteCompany(null);
      setShowModal(false);
    }
  };
  const handleModalOk = async () => {
    try {
      setLoading(true);
      const response = await deleteCompany(deletecompany!.id!);
      const companyDeleted = deletecompany;
      companyDeleted!.is_available = 0;
      setCompanies((companies) =>
        companies.map((company) =>
          company.id === deletecompany!.id ? companyDeleted! : company
        )
      );
      setLoading(false);
      handleSuccess(response);
    } catch (err: any) {
      handleError({ err, type: MessageTypes.error });
    }
    setShowModal(false);
  };

  return (
    <>
      <Title style={{ textTransform: 'capitalize' }} level={2}>
        Compañias
      </Title>
      <Row justify="start" align="middle" style={{ marginBottom: '10px' }}>
        <Col xs={24} sm={12} md={10} lg={8} xl={6}>
          <Link to={`/compañia/crear`}>
            <Button type="primary" block disabled={loading}>
              Agregar nueva compañia
            </Button>
          </Link>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        dataSource={companies}
        loading={loading}
        pagination={{
          position: ['bottomLeft'],
          current: currentpage,
          pageSize: perpage,
          showSizeChanger: true,
          total,
          onChange: (currentPage: number, pageSize: number) => {
            setPerPage(pageSize);
            setCurrentPage(currentPage);
          },
        }}
      />
      <Modal
        title={`Eliminar Compañia`}
        centered
        visible={showmodal}
        confirmLoading={loading}
        onCancel={() => handleModal('close')}
        onOk={handleModalOk}
      >
        <p>
          ¿Estas seguro de querer eliminar la compañia{' '}
          {deletecompany && deletecompany.name}?
        </p>
      </Modal>
    </>
  );
};

export default Company;
